import React, { Suspense, lazy } from "react";
const Navbar = lazy(() => import("../Pages/Navbar"));

const Loading = () => <div className="h-16 bg-white flex items-center">Loading...</div>;

const Layout = ({ children }) => {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Navbar />
      </Suspense>
      <main className="mt-16">{children}</main>
      {/* {<Footer />} */}
    </>
  );
};

export default Layout;
